<template>
  <div>
    <div class="login-container">
      <div class="logo-container">
        <img src="img/logo-bat.svg" alt="Logo de Géobat">
        <h1>Géobat</h1>
      </div>
      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <label for="email">Adresse Email</label>
          <input type="email" name="email" v-model="form.email" placeholder="bruce@waynecorp.com">
        </div>
        <div class="form-group">
          <label for="password">Mot de passe</label>
          <input type="password" required name="password" v-model="form.password">
        </div>
        <div class="form-group">
          <input type="submit" value="Se connecter">
        </div>
      </form>
      <router-link class="createAccountLink" to="/">Créer un compte</router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      form: {
        email: '',
        password: ''
      }
    }
  },
  computed: mapState(['isLogged']),
  methods: {
    login () {
      this.$store.dispatch('login', true)
      this.$router.push({ path: '/' })
    }
  }
}
</script>
